<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="min-height: auto">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="摄像头名称" required prop="name">
                <el-input v-model="addForm.name" placeholder="输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="摄像头序列号" required prop="sn">
                <el-input v-model="addForm.sn" placeholder="输入序列号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="摄像头验证码" required prop="yzm">
                <el-input v-model="addForm.yzm" placeholder="输入验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="通道号" required prop="tdh">
                <el-input v-model="addForm.tdh" placeholder="输入通道号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

      </div>

      <div class="modal-footer">
        <el-button type="default" @click="closeSelf" style="margin-right: 10px">取消</el-button>
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {
      loading: false,

      addForm:{
        timeStr:timeStr,
        sign:'',
        plateform:'shop',
        phone:'',
        institutionCode:'',
        institutionName:'',
        governmentCode:'',

        name:'',
        sn:'',
        yzm:'',
        tdh:'',
      },
      rules:{
        sn:[
          { required: true, message: '输入序列号', trigger: 'blur' },
        ],
        yzm:[
          { required: true, message: '输入验证码', trigger: 'blur' },
        ],
        tdh:[
          { required: true, message: '输入通道号', trigger: 'blur' },
        ],
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' }
        ]
      }
    }
  },
  components:{

  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();
      //console.log(getStaffDTO());
    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      for(let i=0;i<this.arr_ins.length;i++){
        if(this.arr_ins[i].institutionCode == this.addForm.institutionCode){
          this.addForm.institutionName = this.arr_ins[i].userName;
          this.addForm.phone = this.arr_ins[i].userPhone;
          this.addForm.governmentCode = this.arr_ins[i].governmentCode;
        }
      }

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"GroupCamera/Add",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              //this.$message({type: 'success', message: '添加成功'});
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


  }
}


</script>



<style lang="scss" scoped>
</style>
